import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconDuplicateOutlineGroup: React.FC<SvgProps> = (props) => {
  return (
    <>
      <g clipPath="url(#clip0_10077_64488)">
        <path
          d="M12.0163 9L16.1263 11.3475C16.2417 11.4129 16.3377 11.5078 16.4045 11.6224C16.4713 11.737 16.5065 11.8673 16.5065 12C16.5065 12.1327 16.4713 12.263 16.4045 12.3776C16.3377 12.4922 16.2417 12.5871 16.1263 12.6525L9.75131 16.305C9.52328 16.4367 9.26461 16.506 9.00131 16.506C8.738 16.506 8.47933 16.4367 8.25131 16.305L1.8763 12.6525C1.76088 12.5871 1.66488 12.4922 1.59808 12.3776C1.53129 12.263 1.49609 12.1327 1.49609 12C1.49609 11.8673 1.53129 11.737 1.59808 11.6224C1.66488 11.5078 1.76088 11.4129 1.8763 11.3475L5.9863 9"
          stroke="#3B4046"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.75131 10.3051C9.52328 10.4368 9.26461 10.5061 9.00131 10.5061C8.738 10.5061 8.47933 10.4368 8.25131 10.3051L1.8763 6.6526C1.76088 6.58719 1.66488 6.49233 1.59808 6.3777C1.53129 6.26307 1.49609 6.13277 1.49609 6.0001C1.49609 5.86743 1.53129 5.73714 1.59808 5.62251C1.66488 5.50788 1.76088 5.41302 1.8763 5.3476L8.25131 1.6951C8.47933 1.56345 8.738 1.49414 9.00131 1.49414C9.26461 1.49414 9.52328 1.56345 9.75131 1.6951L16.1263 5.3476C16.2417 5.41302 16.3377 5.50788 16.4045 5.62251C16.4713 5.73714 16.5065 5.86743 16.5065 6.0001C16.5065 6.13277 16.4713 6.26307 16.4045 6.3777C16.3377 6.49233 16.2417 6.58719 16.1263 6.6526L9.75131 10.3051Z"
          stroke="#3B4046"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10077_64488">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </>
  );
};

export const IconDuplicateOutlineSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <IconDuplicateOutlineGroup {...props} />
    </svg>
  );
};
